import { render } from "./TimeLine_GDCB.vue?vue&type=template&id=65deed56"
import script from "./TimeLine_GDCB.vue?vue&type=script&lang=js"
export * from "./TimeLine_GDCB.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__